module.exports = require("./pt-CH");